/**
 * (c) 津职模拟考
 */

let url = "http://api.jzkszx.com";
export default {
  url: url,
};
